
export const regions = [
  'Addis Ababa', 
  'Oromia', 
  'Amhara', 
  'SNNPR', 
  'Tigray', 
  'Afar', 
  'Somali',
  'Benishangul-Gumuz',
  'Dire Dawa',
  'Harari',
  'Gambela'
];

export const products = [
  'Coffee', 
  'Wheat', 
  'Barley', 
  'Maize', 
  'Teff', 
  'Sorghum', 
  'Sesame', 
  'Beans'
];

export const farmSizeUnits = ['Hectare', 'Acre', 'Square Meter'];

export const soilTypes = [
  'Clay',
  'Sandy',
  'Silty',
  'Loamy',
  'Chalky',
  'Peaty',
  'Saline'
];

export const waterSources = [
  'River',
  'Lake',
  'Well',
  'Rain',
  'Reservoir',
  'Canal',
  'Spring'
];

export const irrigationTypes = [
  'Drip',
  'Sprinkler',
  'Flood',
  'Furrow',
  'None'
];

export const farmProductStatuses = [
  'planned',
  'planted',
  'growing',
  'harvesting',
  'completed',
  'failed'
];
